import { CommonModule } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-checklist-item-definition-scale',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checklist-item-definition-scale.component.html',
  styleUrl: './checklist-item-definition.shared.css',
})
export class ChecklistItemDefinitionScaleComponent {
  private readonly fb = inject(FormBuilder);

  readonly form = input.required<FormGroup>();
  readonly buckets = input.required<FormArray>();
  readonly i18n = input.required<TranslationService>();
  readonly isReadOnly = input(false);
  readonly addBucketRequested = input.required<() => void>();
  readonly removeBucketRequested = input.required<(index: number) => void>();

  readonly newRuleForm = this.fb.nonNullable.group({
    minValue: [0, Validators.required],
    maxValue: [0, Validators.required],
    score: [0, [Validators.required, Validators.min(0)]],
  });

  constructor() {
    effect(() => {
      if (this.isReadOnly()) {
        this.newRuleForm.disable({ emitEvent: false });
      } else {
        this.newRuleForm.enable({ emitEvent: false });
      }
    });
  }

  asFormGroup(control: unknown): FormGroup {
    return control as FormGroup;
  }

  addRule(): void {
    this.newRuleForm.markAllAsTouched();
    if (this.newRuleForm.invalid) {
      return;
    }

    this.buckets().push(
      this.fb.nonNullable.group({
        minValue: [this.newRuleForm.controls.minValue.getRawValue(), Validators.required],
        maxValue: [this.newRuleForm.controls.maxValue.getRawValue(), Validators.required],
        score: [
          this.newRuleForm.controls.score.getRawValue(),
          [Validators.required, Validators.min(0)],
        ],
      }),
    );

    this.newRuleForm.reset({
      minValue: 0,
      maxValue: 0,
      score: 0,
    });
  }
}
